<template>
  <div class="big-box">
    <div class="scroll-box">
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <div class="big-body">
        <img :src="tapTopUrl" alt="" class="tap-top" />
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <div class="allProgress-box">
            <div class="heart-container">
              <div class="wave-outer-box">
                <div class="wave-box" :style="waveBoxStyle">
                  <div class="wave" :style="waveStyle"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="progress-box" :style="progressNavStyle">
            <div class="progress-box_left">
              <svg
                class="triangle"
                viewBox="0 0 20 50"
                preserveAspectRatio="none"
              >
                <path d="M0,0 L12,15 Q20,25 12,35 L0,50 Z" fill="#FFFFFF" />
              </svg>
              <div class="progress-score">
                <div class="flex-box">
                  <div class="current-score">{{ currentScore }}</div>
                  <div class="total-score ml2">/{{ totalScore }}</div>
                </div>
                <div class="total-score-text mt7">当前总分</div>
              </div>
            </div>
            <div class="progress-box_right">
              <span class="next-text"> 距离下一阶梯还差 </span>
              <span class="next-score">XXXX分</span>
              <div class="progress-bar" :style="progressBarBgStyle">
                <div class="progress-fill" :style="progressFillStyle"></div>
              </div>
            </div>
          </div>
          <div class="draw-time" v-if="ruleDTO.rankPrizeTime">
            <span class="draw-text">距开奖仅剩</span>
            <span class="time-box">{{ timeObj.days }}</span>
            <span class="draw-text">天</span>
            <span class="time-box">{{ timeObj.hours }}</span>
            <span class="draw-text">:</span>
            <span class="time-box">{{ timeObj.minutes }}</span>
            <span class="draw-text">:</span>
            <span class="time-box">{{ timeObj.seconds }}</span>
          </div>
          <div class="draw-time" v-else></div>
          <costomPreviwBtn
            class="apply-box"
            :btnUrl="btnUrl"
            :btnSize="btnSize"
            :isDisabled="getPriviewActTime"
            :btnText="btnText"
            :btnTextStyle="btnTextStyle"
          />
          <div class="unlock-wrap" v-if="newUnlockContentList.length > 1">
            <div
              class="unlock-box"
              :style="{
                backgroundColor: customerPaperwork.unlockBgColor,
                width: 86 * newUnlockContentList.length - 55 + 'px',
              }"
            ></div>
            <div class="unlock-content">
              <div
                class="unlock-item"
                v-for="(item, index) in newUnlockContentList"
                :key="index"
                @click="selectItem(index)"
              >
                <div class="current-box">
                  <div
                    class="unlock-piece"
                    :style="{
                      backgroundColor:
                        item.isLock == 1
                          ? customerPaperwork.lockProgressColor
                          : customerPaperwork.unlockBgColor,
                      color:
                        item.isLock == 1
                          ? '#fff'
                          : currentIndex == index
                          ? customerPaperwork.lockProgressColor
                          : customerPaperwork.unlockTextColor,
                    }"
                  >
                    {{
                      item.isLock == 1
                        ? "已解锁"
                        : item.isLock == 2
                        ? "进行中"
                        : "未解锁"
                    }}
                  </div>
                  <div class="active-box">
                    <div
                      class="progress-active"
                      :style="{
                        backgroundColor: customerPaperwork.lockProgressColor,
                        width: '40%',
                        height: '4px',
                      }"
                      v-if="
                        index < unlockContentList.length - 1 && item.isLock == 1
                      "
                    ></div>
                    <div v-else class="progress-noActive"></div>
                  </div>
                </div>
                <div
                  class="score-text"
                  v-if="item.stageScore"
                  :style="{ color: customerPaperwork.stepTextColor }"
                >
                  {{ item.stageScore }}分
                </div>
                <div class="score-text" v-else></div>
                <div class="select-icon" v-if="currentIndex == index">
                  <img
                    src="https://cdn-image.yucrm.cn/039e54e6178d44a1b3b95f7402295d08.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="one-lock" v-else></div>
          <div class="unlock-img">
            <div class="img-box">
              <img
                v-if="
                  currentUnlockImg.lockPicUrl && currentUnlockImg.isLock != 1
                "
                :src="currentUnlockImg.lockPicUrl"
                alt=""
              />
              <img
                v-else-if="
                  currentUnlockImg.unlockPicUrl && currentUnlockImg.isLock == 1
                "
                :src="currentUnlockImg.unlockPicUrl"
                alt=""
              />
              <div
                class="lock-icon"
                v-if="
                  currentUnlockImg.lockPicUrl || currentUnlockImg.unlockPicUrl
                "
              >
                <img
                  src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/jd-lock-icon.png"
                  alt=""
                />
              </div>
            </div>
            <div class="img-text">{{ currentUnlockImg.stageName }}</div>
          </div>
          <div class="contribution-box" v-if="ruleDTO.isShowRank">
            <div class="contribution-box_title">
              <img
                src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/frame3.png"
                alt=""
              />
              <div class="title-text">贡献榜</div>
              <img
                src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/frame4.png"
                alt=""
              />
            </div>
            <div
              :class="[
                'prize-box',
                newPrizeList.length >= 3 ? 'prize-flex' : 'prize-flex-c',
              ]"
              v-if="ruleDTO.isShowRank && ruleDTO.isOpenPrizes"
            >
              <div
                class="prize-item"
                v-for="(item, index) in newPrizeList"
                :key="index"
              >
                <div class="prize-item_img">
                  <img :src="item.logo" alt="" />
                  <div
                    class="rank-box"
                    v-if="(item.rankStart && item.rankEnd) || item.rankNum"
                  >
                    {{ item.secondText }}
                  </div>
                </div>
                <div class="prize-item_title">{{ item.title }}</div>
              </div>
            </div>
            <div class="rank-footer">
              <img
                src="https://cdn-image.yucrm.cn/80ced7ec914e4e7d92bdf7981d70085e.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
import { useCountDownTime } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation";
import costomPreviwBtn from "@/views/interactiveMarketing/activity/components/commCustomizationSet/costomPreviwBtn.vue";
export default {
  name: "",
  components: {
    costomPreviwBtn,
  },
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
    unlockContentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      progress: 50,
      currentIndex: 0,
      currentObj: {},
      currentPrize: [],
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      timer: null,
      timeObj: {
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
      },
      btnSize: {
        width: "143px",
        height: "36px",
      },
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    progressNavStyle() {
      return `background: ${this.hexToRgba(
        this.customerPaperwork.progressModuleBgColor,
        this.customerPaperwork.navOpacity
      )};color:${this.customerPaperwork.totalTextColor};`;
    },
    waveBoxStyle() {
      let topPosition;
      let opacity = 1;
      if (this.totalScore <= 0 || this.currentScore <= 0) {
        topPosition = 100;
        opacity = 0;
      } else {
        const percent = (this.currentScore / this.totalScore) * 100;
        topPosition = Math.max(0, 100 - percent);
      }
      return `top: ${topPosition}%; opacity: ${opacity}; transition: top 0.5s ease, opacity 0.3s ease;`;
    },
    waveStyle() {
      const bgColor = this.customerPaperwork.totalBgColor || "#c62867";
      return `background: ${bgColor}; transition: background 0.5s ease;`;
    },
    totalBgColor() {
      return this.customerPaperwork.totalBgColor;
    },
    // 总分
    totalScore() {
      return this.unlockContentList.reduce(
        (acc, cur) => acc + cur.stageScore * 1,
        0
      );
    },
    currentScore() {
      return this.totalScore ? Math.floor(this.totalScore * 0.5) : 0;
    },
    progressBarBgStyle() {
      const mainColor = this.customerPaperwork.childBgColor || "#FFB350";
      return `background-color: ${this.lightenColor(mainColor, 0.6)};`;
    },
    progressFillStyle() {
      const mainColor = this.customerPaperwork.childProgressColor || "#FFB350";
      const lightColor = this.lightenColor(mainColor, 0.2);
      return `width: ${this.progress}%;background: repeating-linear-gradient(-45deg, ${mainColor}, ${mainColor} 8px, ${lightColor} 8px, ${lightColor} 16px);`;
    },
    btnTextStyle() {
      return {
        fontSize: "12px",
        color: this.customerPaperwork.btnColor || "#fff",
      };
    },
    newUnlockContentList() {
      return this.unlockContentList.map((item, index) => ({
        ...item,
        currentScore:
          this.unlockContentList.length > 1
            ? +this.unlockContentList[0].stageScore +
              this.unlockContentList[1].stageScore * 0.8
            : 0,
        isLock: index == 0 ? 1 : index == 1 ? 2 : 0,
      }));
    },
    currentUnlockImg() {
      return this.newUnlockContentList[this.currentIndex];
    },
    newPrizeList() {
      return this.productList.map((item, index) => {
        let obj = {
          ...item,
          rankStart: item.scoreRankWinConditionDTO.rankStart,
          rankEnd: item.scoreRankWinConditionDTO.rankEnd,
          rankNum: item.scoreRankWinConditionDTO.rankNum,
          secondText:
            item.scoreRankWinConditionDTO.winType == 0
              ? `TOP${item.scoreRankWinConditionDTO.rankStart}-${item.scoreRankWinConditionDTO.rankEnd}`
              : ` TOP${item.scoreRankWinConditionDTO.rankNum}`,
        };
        return obj;
      });
    },
    getPriviewActTime() {
      if (
        this.compareTime(this.ruleForm.startTime) > this.compareTime(new Date())
      ) {
        return 1;
      } else if (
        this.compareTime(this.ruleForm.endTime) < this.compareTime(new Date())
      ) {
        return 2;
      } else {
        return 3;
      }
    },
    btnText() {
      return this.getPriviewActTime == 1
        ? "活动未开始"
        : this.getPriviewActTime == 2
        ? "活动已结束"
        : "立即报名";
    },
  },
  watch: {
    productList: {
      handler(newVal, oldVal) {
        this.currentPrize = newVal[this.currentIndex];
      },
      deep: true,
    },
    "ruleDTO.rankPrizeTime": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.initCountDown();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    compareTime(time) {
      return new Date(time).getTime();
    },
    selectItem(index) {
      this.currentIndex = index;
    },
    resetTime(obj) {
      if (obj) {
        this.timeObj = obj;
      } else {
        this.timeObj = {
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        };
        clearInterval(this.timer);
      }
    },
    initCountDown() {
      let obj = null;
      obj = useCountDownTime(this.ruleDTO.rankPrizeTime);
      this.resetTime(obj);
      this.timer = setInterval(() => {
        obj = useCountDownTime(this.ruleDTO.rankPrizeTime);
        this.resetTime(obj);
      }, 1000);
    },
    // 将十六进制颜色转换为rgba格式，支持透明度设置，透明度不影响子元素
    hexToRgba(hex, opacity) {
      if (!hex) return "rgba(255,255,255,1)";
      // 处理简写形式 #fff => #ffffff
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const a = opacity / 100;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    // 将颜色变浅，amount 0-1，0不变，1变白
    lightenColor(hex, amount) {
      if (!hex) return "#EBEBEB";
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const num = parseInt(color, 16);
      const r = Math.min(
        255,
        Math.floor((num >> 16) + (255 - (num >> 16)) * amount)
      );
      const g = Math.min(
        255,
        Math.floor(
          ((num >> 8) & 0x00ff) + (255 - ((num >> 8) & 0x00ff)) * amount
        )
      );
      const b = Math.min(
        255,
        Math.floor((num & 0x0000ff) + (255 - (num & 0x0000ff)) * amount)
      );
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 24px;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }

  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 20px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          margin: 0 auto;
          text-align: center;
          width: 65%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .flex-c {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .flex-box {
        display: flex;
        align-items: center;
      }
      .allProgress-box {
        margin: 10px auto 0;
        display: flex;
        justify-content: center;
        overflow: hidden;
        .heart-container {
          position: relative;
          width: 136px;
          height: 110px;
          background: url("https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/aixin.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
        .wave-outer-box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          overflow: hidden;
          -webkit-mask: url("https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/aixin.png")
            no-repeat center center;
          mask: url("https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/aixin.png")
            no-repeat center center;
          -webkit-mask-size: 100% 100%;
          mask-size: 100% 100%;
        }
        .wave-box {
          position: absolute;
          width: 200%;
          height: 200%;
          left: -50%;
        }
        .wave {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-radius: 45% 55%;
          animation: waveMove 3s infinite linear;
          opacity: 0.8;
        }
        .progress-text {
          position: relative;
          z-index: 2;
          font-size: 20px;
          font-weight: bold;
          color: #ad1457;
          font-family: "Microsoft YaHei", sans-serif;
        }
      }
      @keyframes waveMove {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .progress-box {
        margin: 10px auto;
        width: 250px;
        height: 50px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        &_left {
          position: relative;
          padding: 10px 12px;
          width: 100px;
          height: 100%;
          border-radius: 12px;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          .triangle {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -12px;
            width: 20px;
            height: 32px;
          }
          .progress-score {
            font-family: D-DIN Exp-DINExp, D-DIN Exp-DINExp;
            font-weight: bold;
            font-size: 12px;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            // 超出部分省略号

            .current-score {
              max-width: 45px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .total-score {
              max-width: 38px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              opacity: 0.5;
              font-weight: 400;
              font-size: 9px;
              line-height: 9px;
            }
            .total-score-text {
              opacity: 0.5;
              font-weight: 400;
              font-size: 9px;
              line-height: 9px;
            }
          }
        }
        &_right {
          margin-left: 16px;
          flex: 1;
          // height: 100%;
          .next-text {
            opacity: 0.5;
            font-size: 9px;
            line-height: 9px;
          }
          .next-score {
            font-size: 9px;
            line-height: 9px;
            opacity: 1;
            font-weight: bold;
          }
          .progress-bar {
            margin-top: 8px;
            width: 118px;
            height: 10px;
            border-radius: 50px;
            overflow: hidden;
            transition: background-color 0.3s ease;
            .progress-fill {
              height: 100%;
              border-radius: 50px;
              transition: width 0.5s ease, background 0.3s ease;
            }
          }
        }
      }
      .draw-time {
        margin-top: 13px;
        height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        .draw-text {
          font-size: 10px;
          color: rgba(26, 26, 26, 0.7);
        }
        .time-box {
          margin: 0 4px;
          font-size: 10px;
          font-weight: bold;
          color: #1a1a1a;
        }
      }
      .apply-box {
        margin: 7px auto 0;
      }
      .unlock-wrap {
        position: relative;
        height: 55px;
        margin-top: 16px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        &::-webkit-scrollbar {
          width: 4px;
          height: 3px;
        }
        .unlock-box {
          margin-top: 6px;
          height: 8px;
          transform: translateX(21px);
          border-radius: 50px 50px 50px 50px;
        }
        .unlock-content {
          transform: translateX(21px);
          position: absolute;
          top: 4px;
          left: 0;
          display: flex;
          align-items: center;
          .unlock-item {
            position: relative;
            flex-shrink: 0;
            cursor: pointer;
            .current-box {
              width: 84px;
              display: flex;
              align-items: center;

              .unlock-piece {
                width: 35px;
                height: 12px;
                border-radius: 4px;
                line-height: 12px;
                font-size: 8px;
                text-align: center;
              }
              .active-box {
                width: calc(100% - 35px);
                .progress-active {
                  height: 4px;
                }
                .progress-noActive {
                  width: 100%;
                  height: 4px;
                }
              }
            }
            .score-text {
              margin-top: 9px;
              font-family: D-DIN Exp, D-DIN Exp;
              font-weight: 400;
              font-size: 10px;
              height: 10px;
              color: #333333;
              line-height: 10px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .select-icon {
              position: absolute;
              top: 36px;
              left: -16px;
              width: 25px;
              height: 6px;
              .img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
      .one-lock {
        height: 1px;
        margin-top: 10px;
        margin-bottom: 11px;
      }
      .unlock-img {
        margin: 0px auto;
        width: 265px;
        padding: 12px;
        background: #ffffff;
        border-radius: 12px;
        .img-box {
          position: relative;
          width: 242px;
          height: auto;
          // height: 135px;
          border-radius: 10px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .lock-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 50px;
            border: 1px solid #ffffff;
            transform: translate(-50%, -50%);
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 20px;
              height: 20px;
              object-fit: cover;
              border-radius: 50px;
            }
          }
        }
        .img-text {
          margin-top: 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .contribution-box {
        margin-top: 12px;
        width: 100%;
        height: 393px;
        padding: 15px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.5);
        &_title {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          img {
            width: 21px;
            height: 21px;
          }
          .title-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #1a1a1a;
            line-height: 16px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
        .prize-box {
          margin-top: 20px;
          width: 100%;
          overflow-x: hidden;
        }
        .prize-flex {
          display: flex;
          align-items: center;
        }
        .prize-flex-c {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .prize-item {
          flex-shrink: 0;
          width: 87px;
          height: 111px;
          background: #ffffff;
          border-radius: 12px;
          padding: 4px;
          margin-right: 12px;
          &_img {
            position: relative;
            width: 81px;
            height: 81px;
            border-radius: 10px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .rank-box {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 46px;
              height: 15px;
              font-size: 10px;
              background: rgba(0, 0, 0, 0.3);
              border-radius: 0 0 10px 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &_title {
            margin-top: 8px;
            width: 75px;
            height: 13px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 12px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .rank-footer {
          margin: 18px auto;
          width: 256px;
          height: 176px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
  .footer-title {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .mt7 {
    margin-top: 7px;
  }
  .ml2 {
    margin-left: 2px;
  }
  .flex-box {
    display: flex;
  }
}
</style>
